import React from 'react'
import PropTypes from 'prop-types'

import { LayoutConfigType, RoutePropsType } from 'types'

import RouteHandler from 'ui/common/RouteHandler'

const getComponent = () =>
  import(
    /* webpackChunkName: "AccountsAndProperty" */ 'ui/routes/accounts-and-property/routes'
  )

const AccountsAndPropertyRouteHandler = ({ layoutConfig, routeProps }) => (
  <RouteHandler
    getComponent={getComponent}
    layoutConfig={layoutConfig}
    routeProps={routeProps}
  />
)

AccountsAndPropertyRouteHandler.propTypes = {
  layoutConfig: PropTypes.shape(LayoutConfigType).isRequired,
  routeProps: PropTypes.shape(RoutePropsType).isRequired,
}

AccountsAndPropertyRouteHandler.displayName = 'AccountsAndPropertyRouteHandler'

export default AccountsAndPropertyRouteHandler
